const logger = {
    debug: (...args) => {
        if (process.env.REACT_APP_DEBUG === 'true') {
            console.log('[DEBUG]', ...args);
        }
    },
    error: (...args) => {
        if (process.env.REACT_APP_DEBUG === 'true') {
            console.error('[ERROR]', ...args);
        }
    },
    warn: (...args) => {
        if (process.env.REACT_APP_DEBUG === 'true') {
            console.warn('[WARN]', ...args);
        }
    }
};

export default logger;